export default {
  SUPPORT_MGMT_LIST_REQUEST: 'APP/SUPPORT_MGMT/SUPPORT_MGMT_LIST_REQUEST',
  SUPPORT_MGMT_LIST_SUCCESS: 'APP/SUPPORT_MGMT/SUPPORT_MGMT_LIST_SUCCESS',
  SUPPORT_MGMT_LIST_ERROR: 'APP/SUPPORT_MGMT/SUPPORT_MGMT_LIST_ERROR',
};
